<template>
<div class="grid" v-if="theelement">

<!-- not edting -->
<template v-if="!theelement.editing">
 
<div class="col-1 handle flex justify-content-center align-items-center"><i class="pi pi-align-justify"></i></div>
<div class="col-11">

<p>{{theelement.id}}</p>
</div>


</template>
<!-- not edting -->
<!--  edting -->
<template v-if="theelement.editing">


<div class="col-11">
<div class="grid">

<div class="col-12 md:col-2">
<Dropdown v-model="theelement.source_type"  :options="source_types" optionLabel="name" optionValue="id" placeholder="Tür"  class="w-full p-inputtext-sm" @change="sourceTypeSelected"/>
</div>


<div class="col-12 md:col-5" v-if="theelement.source_type">

<template v-if="theelement.source_type=='customattribute'">
  <Dropdown v-model="theelement.source_id"  :options="customattributes" optionLabel="name" optionValue="id" placeholder="Özel Nitelik"  class="w-full p-inputtext-sm" @change="customAttributeSelected"/>
</template>

<template v-if="theelement.source_type=='reportcolumn'">
  <Dropdown v-model="theelement.source_id"  :options="brandreports" optionLabel="name" optionValue="id" placeholder="Marka Raporu"  class="w-full p-inputtext-sm" @change="brandReportSelected"/>
</template>

</div>

<div class="col-12 md:col-5" v-if="theelement.source_type=='reportcolumn' && theelement.source_id">

<Dropdown v-model="theelement.sourceitem_id"  :options="reportcolumns" optionLabel="name" optionValue="id" placeholder="Rapor Sütunu"  class="w-full p-inputtext-sm" @change="reportColumnSelected" :loading="reportcolumnsloading"/>
</div>


</div>
</div>




<div class="flex align-items-start justify-content-end col-12 md:col-1">
<Button icon="pi pi-check" class=" p-button-success p-button-outlined  p-button-sm mr-2" @click="submitNewItem"></Button>

<Button icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm mr-2" @click="cancelSubmitNewItem"></Button>
</div>



</template>
<!--  edting -->


<div class="col-12"><hr></div>
</div>

</template>

<script>
export default {

  name: 'BrandSupplierScorecardItem',
  props:["element","customattributes","languages","brandreports"],
  data () {
    return {
      source_types:[
        {name:"Özel Nitelik",id:"customattribute"},
        {name:"Rapor Sütunu",id:"reportcolumn"}
      ],
      theelement:null,
      reportcolumns:[],
      reportcolumnsloading:false,
    }
  },
  mounted()
  {
    this.theelement = this.element
    console.log("theelement")
  },
  methods:{
    submitNewItem()
    {
      console.log(this.theelement);
    },
    cancelSubmitNewItem()
    {

    },
    sourceTypeSelected(data)
    {
      console.log(data)
      this.theelement.source_id = null
      this.theelement.sourceitem_id = null
    },
    customAttributeSelected(data)
    {
      console.log(data)
    },
    async brandReportSelected(data)
    {
      console.log(data)
      this.reportcolumnsloading = true
      let reportcolumns = await this.generalApiGetWithoutLoader("brand_report_columns/"+this.theelement.source_id)
      console.log(this.reportcolumns);
      this.reportcolumns = reportcolumns.columns
      this.reportcolumnsloading = false
    },
    reportColumnSelected(data)
    {
      console.log(data)
    },
  }
}
</script>

<style lang="css" scoped>
</style>